'use no memo';

/* eslint-disable import/prefer-default-export */
import React from 'react';
import cx from 'classnames';

type OutlinkProps = {
  ariaLabel?: string;
  className?: string;
  children: React.ReactNode;
  dataTestId?: string;
  handleClick?: React.MouseEventHandler<HTMLAnchorElement>;
  id?: string;
  inline?: boolean;
  to: string;
};

const outlinkClasses =
  'text-sm leading-4 tracking-normal text-[color:var(--contentPrimary)] hover:text-[color:var(--contentActive)] active:text-[color:var(--contentActive)] focus:outline-1 focus:outline-dashed focus:outline-[var(--contentPrimary)] focus-visible:outline-1 focus-visible:outline-dashed focus-visible:outline-[var(--contentPrimary)]';

export const Outlink: React.FunctionComponent<OutlinkProps> = ({
  ariaLabel,
  className,
  children,
  dataTestId,
  handleClick,
  id,
  inline = false,
  to,
}) => (
  <a
    href={to}
    id={id}
    data-testid={dataTestId || 'Outlink'}
    aria-label={ariaLabel}
    className={cx(outlinkClasses, inline ? 'inline' : 'flex', className)}
    // tabIndex is required for accessibility to ensure the button
    // can be focused and activated via keyboard on Safari
    tabIndex={0}
    target="_blank"
    rel="noreferrer"
    onClick={handleClick}
  >
    {children}
  </a>
);
